export default "__VITE_ASSET__893feeae__"